module.exports = __webpack_public_path__ + "static/media/visa.05d2d57a.svg";